import type { ComponentType } from "react";
import type { ReportSection as ReportSectionType } from "@/types/report";
import {
  HeadlineSection,
  StatsBandSection,
  SummarySection,
  ProseSection,
  ChartSection,
  TableSection,
  ImageSection,
  CalloutSection,
  FaqSection,
  SourcesSection,
  FooterSection,
} from "./sections";

const SECTION_MAP: Record<string, ComponentType<{ content: any }>> = {
  headline: HeadlineSection,
  "stats-band": StatsBandSection,
  summary: SummarySection,
  prose: ProseSection,
  chart: ChartSection,
  table: TableSection,
  image: ImageSection,
  callout: CalloutSection,
  faq: FaqSection,
  sources: SourcesSection,
  footer: FooterSection,
};

interface Props {
  section: ReportSectionType;
}

export function ReportSection({ section }: Props) {
  const Component = SECTION_MAP[section.type];
  if (!Component) return null;

  return (
    <div
      className={`report-section ${section.visible ? "visible" : ""}`}
      data-section-id={section.id}
    >
      <Component content={section.content} />
    </div>
  );
}
